import RuleDetailsParser from "./RuleDetailsParser";
import { MainPointOutType, RuleType } from '../../@types/rule-type';
//指摘メッセージから指摘範囲を取得する為の定数
const exceptionRules = [
    { rule: 'prh', offset: 2 },
    { rule: 'custom-rule-ja-no-double-mean', offset: 2 },
    { rule: 'custom-rule-ad-era-year-mismatch', offset: 2 },
    { rule: 'custom-rule-2.2.3.js', offset: 2 },
    { rule: 'custom-rule-2.2.2.js', offset: 2 },
    { rule: 'custom-rule-2.2.1.js', offset: 2 },
    { rule: 'custom-rule-2.1.5.js', offset: 2 },
    { rule: 'custom-rule-2.1.6.js', offset: 2 },
    { rule: 'custom-rule-date-weekday-mismatch', offset: 4 },
    { rule: 'custom-rule-ja-no-orthographic-variants', specialWord: '］', offset: 2 },
    { rule: 'custom-rule-ja-no-weak-phrase', specialWord: '］', offset: 6 },
    { rule: 'custom-rule-no-doubled-conjunction', specialWord: '］', offset: 7 },
];
export default class LintErrorPoints {
    result;
    rulePaths;
    ruleConfigs;
    ignoreRuleIds;
    kuromojiResponse;
    // プリセットを跨ぐ重複ルール
    static notActiveRules = [
        '@textlint-ja/no-synonyms',
        'jtf-style/1.1.5.図表のキャプション',
        'jtf-style/1.1.3.箇条書き',
        'jtf-style/1.1.2.見出し',
        // 'jtf-style/2.2.2.算用数字と漢数字の使い分け',
        'ja-technical-writing/no-unmatched-pair',
        'ja-technical-writing/no-doubled-conjunction',
        'ja-spacing/ja-space-after-exclamation',
        'ja-spacing/ja-no-space-between-full-width',
        'ja-spacing/ja-no-space-around-parentheses',
        'ja-spacing/ja-nakaguro-or-halfwidth-space-between-katakana',
        'ja-spacing/ja-space-between-half-and-full-width',
    ];
    constructor(result, rulePaths, ruleConfigs, ignoreRuleIds, kuromojiResponse) {
        this.result = result;
        this.rulePaths = rulePaths;
        this.ruleConfigs = ruleConfigs;
        this.ignoreRuleIds = ignoreRuleIds;
        this.kuromojiResponse = kuromojiResponse;
        this.result = result;
        this.rulePaths = rulePaths;
        this.ruleConfigs = ruleConfigs;
        this.ignoreRuleIds = ignoreRuleIds;
        this.kuromojiResponse = kuromojiResponse;
    }
    createProofreadingPoints() {
        if (this.result == 'success') {
            return this.generateSuccessResponse();
        }
        const errorPointsMap = {};
        let errorPointIndex = 0;
        const ignoreIdx = this.getIgnoreRuleIdx();
        const ruleDetailsParser = new RuleDetailsParser(this.rulePaths, this.ruleConfigs);
        this.result.forEach((result, order) => {
            if (ignoreIdx.includes(order))
                return;
            const [message, pairObj] = this.extractAdditionalInfo(result.message);
            const { ruleName, ruleId, ruleDtlId, uniqueId, ruleUrl, isClientDic, pointOutMessage, ruleType } = ruleDetailsParser.parseMessageDetails(result, message);
            //無視するで追加されたルールは無視する
            if (this.ignoreRuleIds.includes(uniqueId))
                return;
            const fixableFlg = this.isFixable(result, ruleName, ruleId, ruleType);
            let newErrorPoints = [];
            //　ペアとなるエラーポイントがある場合は、それも追加する([組み立て]と][組立て] ---二重表現)
            if (result.ruleId === 'custom-rule-ja-no-orthographic-variants') {
                newErrorPoints = this.createVariantsErrorPoint(pairObj, message, order, result.index, uniqueId);
            }
            else {
                newErrorPoints = this.addErrorPoint(result, order, uniqueId, pairObj);
            }
            const addErrorPoints = [];
            newErrorPoints.forEach((result) => {
                addErrorPoints.push({
                    ...result,
                    resultHtmlInfo: {
                        message: pointOutMessage.replace(/=>/g, "➡"),
                        ruleName: ruleName,
                        ruleId: ruleId,
                        ruleDtlId: ruleDtlId,
                        uniqueId: uniqueId,
                        ruleUrl: ruleUrl,
                        isClientDic: isClientDic,
                        fixableFlg: fixableFlg,
                        ruleType: ruleType,
                    },
                });
            });
            for (const errorPoint of addErrorPoints) {
                errorPointsMap[errorPointIndex] = errorPoint;
                errorPointIndex++;
            }
        });
        return Object.values(errorPointsMap);
    }
    /**
     * ■if文のコメントアウトについて（2024/08/22）
     * 形態素解析の影響により、ユーザーが辞書で登録する単語によっては指摘される、指摘されないなどの差異が生じて不具合が発生しているため、if文の処理は一旦コメントアウトで対応
     */
    getIgnoreRuleIdx() {
        const ignoreIdx = [];
        // if( Array.isArray(this.result) && this.result.length >= 1 ){
        //     let index = 0;
        //     this.result.forEach( ({ ruleId , range, message} ) => {
        //         if(ruleId === 'prh'){
        //             this.kuromojiResponse.forEach( ({surface_form, word_position } )=> {
        //                 if( word_position <= range[1] && range[1] <=word_position+surface_form.length){
        //                     const errorWord = message.slice(0,message.indexOf('=>',0));
        //                     if(errorWord.trim().length < surface_form.length){
        //                         ignoreIdx.push(index);
        //                     }
        //                 }
        //             });
        //         }
        //         index++;
        //     })
        // }
        return ignoreIdx;
    }
    /**
     * 自動修正可能かどうかを判定する
     * ユーザー辞書、クライアント辞書の場合は自動修正可能
     * また、fixableMapに含まれる場合も自動修正可能(6/17 デジタル様管理の辞書でOFFのものがある)
     */
    isFixable(result, ruleId, id, ruleType) {
        let isFixable = false;
        if (ruleId === 'prh' || result.hasOwnProperty('fix')) {
            if (ruleType === RuleType.CLIENT_DIC || ruleType === RuleType.USER_DIC)
                isFixable = true;
            if (this.ruleConfigs.fixableMap[id]) {
                isFixable = true;
            }
            //ruleTypeがADMIN_DIC,OTHERの場合は自動修正不可とする2024/8/29
            if (ruleType === RuleType.ADMIN_DIC || ruleType === RuleType.OTHER)
                isFixable = false;
        }
        return isFixable;
    }
    /**
     * @param resultMessage
     * @returns {string} message
     * @returns {object} additionalInfo
     *
     * textlintから返された指摘箇所以外の該当箇所を取得する
     * 例)
     * sentence　: 確かにそういった懸念[は]ない事[は]ない。
     * message : "１つの文章で同じ助詞［は］を使用しています。読みにくくないか注意してください。"{"prev": 4}""
     * この場合、"{"prev": 4}"を取得し、指摘箇所以外の該当箇所を取得する
     *　{"prev"}がない場合は、nullを返す
     */
    extractAdditionalInfo(resultMessage) {
        const regex = /"\{[^{}]*\}"/;
        const match = resultMessage.match(regex);
        let additionalInfo = null;
        let message = resultMessage;
        if (match) {
            const matchedObjectString = match[0].slice(1, -1);
            try {
                const potentialObject = JSON.parse(matchedObjectString);
                if ("prev" in potentialObject) {
                    additionalInfo = potentialObject;
                }
            }
            catch (error) {
                console.error("JSON parsing error in extractAdditionalInfo:", error);
            }
            message = resultMessage.replace(regex, "").trim();
        }
        // 指摘は pre-wrap で表示するため、ルールのソース由来のインデントと前後の改行を落とす。
        // 辞書の語句の空白は残す必要があるので、改行に続く半角の空白だけを対象にする（\s は全角スペースにも一致する）
        message = message
            .replace(/\n[ \t\r\n]*/g, "\n")
            .replace(/^\n+|\n+$/g, "");
        return [message.replace("\n", "<br>"), additionalInfo];
    }
    generateSuccessResponse() {
        return [];
    }
    addErrorPoint(result, order, uniqueId, pairObj) {
        const addErrorPoints = [];
        const processErrorPoint = (prev) => {
            const index = result.index - prev;
            addErrorPoints.push(this.createErrorPoint(result.message, result.ruleId, order, index, uniqueId));
        };
        if (pairObj != null) {
            if (Array.isArray(pairObj.prev)) {
                pairObj.prev.forEach(processErrorPoint);
            }
            else {
                processErrorPoint(pairObj.prev);
            }
        }
        addErrorPoints.push(this.createErrorPoint(result.message, result.ruleId, order, result.index, uniqueId));
        return addErrorPoints;
    }
    createErrorPoint(message, ruleId, order, index, uniqueId) {
        const range = this.getRange(message, ruleId);
        return {
            type: MainPointOutType.LINT,
            index: index,
            order: order,
            range: range,
            uniqueId: uniqueId,
        };
    }
    /**
     *
     * @param message
     * @param ruleId
     * @returns
     * 指摘メッセージから指摘範囲を取得する
     * 例) 怪我 ➡ けが
     * メッセージから怪我という、特定の単語を取得し文字数を返す
     */
    getRange(message, ruleId) {
        const targetRule = exceptionRules.find(r => r.rule === ruleId);
        if (!targetRule) {
            return 0;
        }
        if (targetRule.specialWord) {
            return Math.max(0, message.indexOf(targetRule.specialWord) - targetRule.offset);
        }
        else {
            const arrowIndex = message.indexOf('=>');
            if (arrowIndex === -1) {
                return 0;
            }
            else {
                return Math.max(0, arrowIndex - targetRule.offset);
            }
        }
    }
    createVariantsErrorPoint(pairObj, message, order, index, uniqueId) {
        if (pairObj === null)
            return [];
        const addErrorPoints = [];
        const prev = pairObj.prev;
        const pointOutLength = pairObj.pointOutLength;
        addErrorPoints.push(this.createErrorPoint(message, 'custom-rule-ja-no-orthographic-variants', order, index, uniqueId));
        prev.forEach((prev, i) => {
            const newIdx = index - prev;
            addErrorPoints.push({
                type: MainPointOutType.LINT,
                index: newIdx,
                order: order,
                range: pointOutLength[i] - 1,
                uniqueId: uniqueId,
            });
        });
        return addErrorPoints;
    }
}
